import BaseTable, {AutoResizer, SortOrder} from 'react-base-table'
import React, {useEffect, useState} from 'react';
import 'react-base-table/styles.css'
import './base-table.css'
import styled from 'styled-components';

const ItemTable = ({itemData}) => {
    const [data, setData] = useState({});
    const [sortBy, setSortBy] = useState({
        key: 'nsn', 
        order: SortOrder.ASC
    })

    useEffect(() => {
    
        setData(itemData.map((doc, index) => {
            return {
                nsn: doc.nsn,
                itemName: doc.item_name,
                endItemName: doc.end_item_name,
                securityClassification: doc.security_classification,
        
            }
        }));
    }, [itemData])

    const columns = [
        {
            key: 'nsn',
            dataKey: 'nsn',
            title: 'NSN',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },

        {
        key: 'itemName',
        dataKey: 'itemName',
        title: 'Item Name',
        width: 150,
        align: 'center',
        resizable: true,
        sortable: false
        },
        {
        key: 'endItemName',
        dataKey: 'endItemName',
        title: 'End Item Name',
        width: 150,
        align: 'center',
        resizable: true,
        sortable: false
        },

        {
        key: 'securityClassification',
        dataKey: 'securityClassification',
        title: 'Security Classification',
        width: 150,
        align: 'center',
        resizable: true,
        sortable: false
        }
        
    ]

    const Container = styled.div`
        width: calc(50vw + 220px);
        height: 50vh;
        `


return (
    <>
        <Container>
            <AutoResizer>
                {({ width, height }) => (
                    <BaseTable
                        className='base-table'
                        width={width}
                        height={height}
                        columns={columns}
                        data={data}
                        sortBy={sortBy}
                        
                    />
                )}
            </AutoResizer>
        </Container>
    </>
    );
}

export default ItemTable